import t from "react";
import { Context as o } from "../context.js";
function n() {
  return t.useContext(o);
}
export {
  n as useNavigation
};
//# sourceMappingURL=useNavigation.js.map
